import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import {
  AuthUrlResponse,
  NoUserService,
} from '@app/service/no-user-service/no-user.service';
import { StateService } from '@app/service/state/state.service';
import { StandardCheckoutResponse } from '@app/service/user-service/user.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoggingService } from '@app/service/logging-service/logging.service';
import { QueryParamsService } from '@app/service/query-params/query-params.service';

@Component({
  selector: 'no-auth',
  templateUrl: './no-auth.component.html',
  styleUrls: ['../../page-shared.css', './no-auth.component.scss'],
})
export class NoAuthComponent extends RouteComponent implements OnInit {
  form: FormGroup;

  ctaButtonText: string = 'Identifisere';
  public authInProgress = false;
  public authComplete = false;
  public authError: boolean = false;

  public loadingText = 'Venter på BankID-identifikasjon...';

  showError: boolean;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected queryParamsService: QueryParamsService,
    private noUserService: NoUserService,
    private formBuilder: FormBuilder,
    private loggingService: LoggingService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    const success = this.queryParamsService.getQueryParams().success;
    const transaction_id =
      this.queryParamsService.getQueryParams().transaction_id;

    if (success) {
      if (success === 'true' && transaction_id) {
        this.loggingService.log(
          `Came back from Scrive with following params: ?transaction_id=${transaction_id}&success=${success}`
        );
        this.handleCallback();
        return;
      } else {
        this.authError = true;
      }
    }

    this.setupForm();
  }

  setupForm(): void {
    this.form = this.formBuilder.group({
      pnr: ['', []],
    });
  }

  async handleCtaClick() {
    if (this.validateNorwegianIdNumber(this.form.value.pnr)) {
      this.authInProgress = true;

      try {
        const returnUrl: string = window.location.href.split('&')[0];
        await this.noUserService
          .initAuth(this.form.value.pnr, returnUrl)
          .then((resp: AuthUrlResponse) => {
            this.authError = false;

            this.loggingService.log(
              'Leaving checkout to enter Scrive Auth flow'
            );
            window.location.href = resp.accessUrl;
          });
      } catch (err) {
        this.handleError(err);
        // navigate on error to avoid hanging in loading state
        this.navigate();
      }
    } else {
      this.showError = true;
    }
  }

  validateNorwegianIdNumber(idNumber: string): boolean {
    const trimmed = idNumber.trim();
    if (isNaN(Number(trimmed))) return false;
    if (trimmed.length !== 11) return false;
    if (this.isValidCheckDigits(trimmed)) return true;
  }

  isValidCheckDigits(elevenDigits: string): boolean {
    const staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
    const staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];

    const elevenDigitsArray = elevenDigits.split('').map(Number);

    return (
      this.isValidCheckDigit(
        staticSequenceFirstCheckDigit,
        elevenDigitsArray
      ) &&
      this.isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray)
    );
  }

  isValidCheckDigit(staticSequence: number[], elevenDigits: number[]): boolean {
    const productSum = staticSequence.reduce(
      (acc, value, index) => acc + value * elevenDigits[index],
      0
    );

    return productSum % 11 === 0;
  }

  async handleCallback(): Promise<void> {
    this.authInProgress = false;
    this.authComplete = true;
    this.loadingText = 'Vente...';
    try {
      //maybe check if transaction id matches
      let resp: StandardCheckoutResponse = await this.noUserService.authorize();
      if (resp.success) {
        this.navigate();
      }
    } catch (err) {
      this.handleError(err);
      // navigate on error to avoid hanging in loading state
      this.navigate();
    }
  }
}
